import api from 'api';

export const createMessage = api('POST /api/gallery/ai-chatbot/message');
export const getJobStatus = api(
  'GET /api/gallery/ai-chatbot/message/jobs/:jobId'
);
